import { useCallback } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';

export type IsAliveFn = () => boolean;

// Use this hook to ensure that your component is still mounted before mutating state.
export const useAlive = (): IsAliveFn => {
  const isAlive = useRef(true);

  // Set isAlive to false when the component unmounts.
  useEffect(() => {
    return () => {
      isAlive.current = false;
    };
  }, []);

  return useCallback(() => isAlive.current, []);
};
